import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { STYLE_COLLECTIONS } from '../utils';

const tabStyle = isActive => ({
  fontWeight: isActive && 'bold',
  padding: '8px 4px',
  borderBottom: isActive && '2px solid #000',
  cursor: 'pointer',
});

export default function StyleCollectionTabs({ value, onChange }) {
  return (
    <Grid container justifyContent="center" style={{ margin: '10px 0px 40px' }}>
      {STYLE_COLLECTIONS.map(({ key, label }, index) => (
        <Typography
          key={key}
          onClick={() => onChange(key)}
          style={{
            ...tabStyle(value === key),
            marginLeft: index === 0 ? 0 : '10%',
          }}
        >
          {label}
        </Typography>
      ))}
    </Grid>
  );
}
